module.exports = __webpack_public_path__ + "imgs/gps.79f81c9ff946262ef1ebf3241e71a94a.svg";